import { useState, useEffect } from 'react';
import { AVAILABLE_SERVICES } from '../constants/doctorOptions';
import type { AvailableTask } from '../types/doctor';

/**
 * 対応可能業務のマスターデータを取得するカスタムフック
 * 
 * 意図：
 * - 対応可能業務のマスターデータを提供
 * - 将来的にAPIから取得する場合の拡張性を確保
 * 
 * 注意点：
 * - 現在は定数から取得しているが、将来的にはAPIから取得する可能性がある
 * - バックエンドの値と同期を保つ必要がある
 */
export const useAvailableServices = () => {
  const [services, setServices] = useState<AvailableTask[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 現在は定数から取得
    // 将来的にAPIから取得する場合はここを変更
    try {
      setServices(AVAILABLE_SERVICES);
      setIsLoading(false);
    } catch (err) {
      setError('対応可能業務の取得に失敗しました');
      setIsLoading(false);
    }
  }, []);

  return {
    services,
    isLoading,
    error
  };
};